const GET_LOCATION_START = "user/GET_LOCATION_START";
const GET_LOCATION_SUCCESS = "user/GET_LOCATION_SUCCESS";
const GET_LOCATION_ERROR = "user/GET_LOCATION_ERROR";

export default {
  GET_LOCATION_SUCCESS,
  GET_LOCATION_START,
  GET_LOCATION_ERROR,
};
